const productImg = (id, kind) => `/assets/products/blend/${id}_${kind}.webp`;

export const IMAGES = {
  heroForest: "/assets/hero-forest.webp",
  familyShelf: "/assets/products/blend/family.webp",
  ezekiel: "/assets/ezekiel.webp",
  kane: "/assets/kane.webp",
  malakai: "/assets/malakai.webp",
  ele: "/assets/ele.webp",
  brandBanner: "/assets/brand-banner.webp",
  gather: "/assets/editorial/standard-gather.webp",
  measure: "/assets/scenes/measure-apothecary.webp",
  shelf: "/assets/editorial/standard-shelf.webp",
  truck: "/assets/scenes/four-dogs-truck.webp",
  field: "/assets/scenes/dogs-field-run.webp",
  map: "/assets/foragers-map.webp",
};

const gallery = (id, kinds) => kinds.map((k) => productImg(id, k));

const PRODUCT_LIST = [
  {
    id: "foresters_guard",
    slug: "foresters-guard",
    bestFor: "Daily foundation",
    pagePill: "Best for most dogs, most days",
    plain: "Turkey tail",
    subtitle: "Turkey tail · Trametes versicolor · mushroom powder",
    lead: "Turkey tail and nothing else.",
    leadRest: "Wild-gathered after the first frost from fallen birch and poplar. Our everyday jar, and the first one we made.",
    sourcing: { mushroom: "Turkey tail · Trametes versicolor", origin: "Wild-gathered after the first frost, from fallen birch & poplar" },
    dogNote: { dog: "Ele", text: "The Guard. She inspects every batch personally and has never once been wrong." },
    gallery: gallery("foresters_guard", ["spot", "scene"]),
    batchNo: "FS-07",
    lookupKey: "foresters_guard",
    soLookupKey: "so_foresters_guard",
    name: "The Forester's Guard",
    latin: "Trametes versicolor",
    blurb: "Turkey tail, walked in from the treeline. The daily foundation.",
    story:
      "Our first preparation, and still the one we reach for. Turkey tail and nothing else, gathered after the first frost from fallen birch and poplar. A quiet, daily measure for dogs who spend their lives outdoors — and for those who only dream of it.",
    suited: "For most dogs, most days.",
    priceCents: 6800,
    soPriceCents: 6120,
    image: productImg("foresters_guard", "spot"),
    imageForest: productImg("foresters_guard", "scene"),
    sceneCaption: "On the fallen birch — where the jar begins.",
    vessel: "Amber glass · 60 g · 60 measures",
  },
  {
    id: "trailhead_vigor",
    slug: "trailhead-vigor",
    bestFor: "Working & adventure",
    pagePill: "Best for working dogs and tireless companions",
    plain: "Cordyceps",
    subtitle: "Cordyceps · Cordyceps militaris · mushroom powder",
    lead: "Cultivated cordyceps, never wild-taken.",
    leadRest: "Grown patiently on hardwood, for working dogs and the hopelessly high-spirited.",
    sourcing: { mushroom: "Cordyceps · Cordyceps militaris", origin: "Cultivated, never wild-taken" },
    dogNote: { dog: "Malakai", text: "Vigor. Works weekends. Does not understand the concept of weekends." },
    gallery: gallery("trailhead_vigor", ["spot", "scene"]),
    batchNo: "TV-05",
    lookupKey: "trailhead_vigor",
    soLookupKey: "so_trailhead_vigor",
    name: "Trailhead Vigor",
    latin: "Cordyceps militaris",
    blurb: "Cultivated cordyceps for the dog who reads the trail before you do.",
    story:
      "For working dogs and the hopelessly high-spirited. Cordyceps grown patiently on hardwood — never wild-taken — prepared for the ones who consider a twenty-kilometre day a warm-up.",
    suited: "For working dogs and tireless companions.",
    priceCents: 6400,
    soPriceCents: 5760,
    image: productImg("trailhead_vigor", "spot"),
    imageForest: productImg("trailhead_vigor", "scene"),
    sceneCaption: "At the trailhead, under a dawn sky — where the jar begins.",
    vessel: "Amber glass · 60 g · 60 measures",
  },
  {
    id: "grey_muzzle_reserve",
    slug: "gray-muzzle-reserve",
    bestFor: "Senior dogs",
    pagePill: "Best for senior dogs, and dogs becoming senior",
    plain: "Lion's mane",
    subtitle: "Lion's mane · Hericium erinaceus · mushroom powder",
    lead: "Lion's mane and nothing else.",
    leadRest: "Set aside for the gray-muzzled members of the household, and chosen by Ezekiel.",
    sourcing: { mushroom: "Lion's mane · Hericium erinaceus", origin: "Cultivated" },
    dogNote: { dog: "Ezekiel", text: "The Reserve. The Chief of Staff does not explain his choices." },
    gallery: gallery("gray_muzzle_reserve", ["spot"]),
    batchNo: "AS-11",
    lookupKey: "grey_muzzle_reserve",
    soLookupKey: "so_grey_muzzle_reserve",
    name: "The Gray Muzzle Reserve",
    latin: "Hericium erinaceus",
    blurb: "Lion's mane, set aside for the elders of the pack.",
    story:
      "Our tenderest work. Lion's mane, grown on maple until it cascades. Set aside for the gray-muzzled members of the household, and chosen by Ezekiel. Made for dogs who have earned every gray hair, and for the people who count them.",
    suited: "For senior dogs, and dogs becoming senior.",
    priceCents: 7200,
    soPriceCents: 6480,
    image: productImg("gray_muzzle_reserve", "spot"),
    imageForest: productImg("grey_muzzle_reserve", "scene"),
    sceneCaption: "By the window, in the good light — where the jar rests.",
    vessel: "Amber glass · 60 g · 60 measures",
  },
  {
    id: "riverbend_calm",
    slug: "riverbend-calm",
    bestFor: "Watchful & worried",
    pagePill: "Best for the watchful, the worried, the thunder-counting",
    plain: "Reishi",
    subtitle: "Reishi · Ganoderma tsugae · mushroom powder",
    lead: "Reishi and nothing else.",
    leadRest: "Steeped long and low for the dog who hears the storm an hour before the sky does.",
    sourcing: { mushroom: "Reishi · Ganoderma tsugae", origin: "Cultivated" },
    dogNote: { dog: "Kane", text: "Calm. He hears the storm an hour before you do, and would like you to know." },
    gallery: gallery("riverbend_calm", ["spot", "scene"]),
    batchNo: "KM-03",
    lookupKey: "riverbend_calm",
    soLookupKey: "so_riverbend_calm",
    name: "Riverbend Calm",
    latin: "Ganoderma tsugae",
    blurb: "A single-minded reishi preparation for thunderstorms, fireworks, and Mondays.",
    story:
      "One mushroom, taken seriously. Reishi steeped long and low for the dog who hears the storm an hour before the sky does. Nothing added to distract from the point.",
    suited: "For the watchful, the worried, the thunder-counting.",
    priceCents: 6200,
    soPriceCents: 5580,
    image: productImg("riverbend_calm", "spot"),
    imageForest: productImg("riverbend_calm", "scene"),
    sceneCaption: "At the riverbend, at dusk — where the jar begins.",
    vessel: "Amber glass · 60 g · 60 measures",
  },
  {
    id: "discovery_dram",
    slug: "discovery-dram",
    bestFor: "Start here",
    pagePill: "Best for the undecided, and their dogs",
    plain: "Three small drams",
    subtitle: "Trailhead Vigor · Riverbend Calm · The Forester's Guard",
    lead: "Vigor, Calm and the Guard in three small drams.",
    leadRest: "Two weeks to let your dog cast the deciding vote.",
    dogNote: null,
    gallery: gallery("discovery_dram", ["spot"]),
    batchNo: "DD-02",
    lookupKey: "discovery_dram",
    soLookupKey: null,
    name: "The Discovery Dram",
    latin: "Tria genera · a tasting in three parts",
    blurb: "Trailhead Vigor, Riverbend Calm and The Forester's Guard — three small drams, a fortnight's introduction.",
    story:
      "Every apothecary keeps a tasting shelf. Three small drams — Vigor, Calm, and the Guard — enough for two weeks of honest trial, so the dog can cast the deciding vote before you commit to the full jars.",
    suited: "For the undecided, and their dogs.",
    priceCents: 2900,
    soPriceCents: null,
    image: productImg("discovery_dram", "spot"),
    imageForest: null,
    vessel: "Three drams · 3 × 10 g",
  },
];

const SHELF_ORDER = ["foresters_guard", "trailhead_vigor", "riverbend_calm", "grey_muzzle_reserve", "discovery_dram"];
export const PRODUCTS = SHELF_ORDER.map((id) => PRODUCT_LIST.find((p) => p.id === id));
export const JARS = PRODUCTS.filter((p) => p.id !== "discovery_dram");
export const productBySlug = (slug) => PRODUCTS.find((p) => p.slug === slug);
export const productById = (id) => PRODUCTS.find((p) => p.id === id);
export const productPath = (p) => `/products/${p.slug}`;
export const JAR_MEASURES = 60;
export const doseForLb = (lb) => DOSING_BANDS.find((b) => Math.min(lb, 140) <= b.maxLb) || DOSING_BANDS[DOSING_BANDS.length - 1];
export const daysForLb = (lb) => Math.floor(JAR_MEASURES / doseForLb(lb).dose);
export const formatShort = (cents) => (document.documentElement.lang === "fr" ? `${cents / 100} $` : `$${cents / 100}`);

export const DOSING_BANDS = [
  { maxLb: 25, dose: 0.25, label: "a quarter measure" },
  { maxLb: 50, dose: 0.5, label: "a half measure" },
  { maxLb: 90, dose: 0.75, label: "three quarters of a measure" },
  { maxLb: 140, dose: 1, label: "one full measure" },
];

export const DOGS = [
  {
    name: "Ezekiel",
    slug: "ezekiel",
    motto: "Wild heart · Keen eyes",
    trail: "The slow loop through the spruce behind the house, taken at a dignified pace, with frequent stops for inspection.",
    title: "Chief of Staff",
    breed: "Brindle gentleman, senior grade",
    note: "Presides over all meetings from a seated position of considerable gravity. Founded the company by walking into it and declining to leave. The grey at his muzzle is not age; it is seniority.",
    image: IMAGES.ezekiel,
    portrait: true,
  },
  {
    name: "Kane",
    slug: "kane",
    motto: "Strong heart · Soft soul",
    trail: "Any trail that ends in an open field of tall grass, ideally followed by a nap somewhere soft.",
    title: "Junior Taste Inspector",
    breed: "Brindle gentleman, junior grade",
    note: "Junior in title only. Approaches each tasting with the gravity of a wine critic and the manners of a dog half his size. The bone in his portrait was a prop; he has not returned it.",
    image: IMAGES.kane,
    portrait: true,
  },
  {
    name: "Malakai",
    slug: "malakai",
    motto: "Curious heart · Loyal companion",
    trail: "The lakeshore path below the mountains, where every log needs checking and the dinosaur comes too.",
    title: "Head of Field Research",
    breed: "Pit bull, senior researcher",
    note: "Has personally inventoried every mushroom patch in the Kananaskis, and one purple dinosaur, which he also inventories daily. Works weekends. Does not understand the concept of weekends.",
    image: IMAGES.malakai,
    portrait: true,
  },
  {
    name: "Ele",
    display: "Eleanor",
    slug: "ele",
    motto: "Bright spirit · True north",
    trail: "The wildflower meadow at first light, walked in a straight line, always leading the way.",
    title: "Keeper of the Ledger",
    breed: "Of uncertain lineage, certain authority",
    note: "No batch leaves the shelf without her inspection. Her method is olfactory, her standards absolute, her paw-print on every label she approves. The crown is not ceremonial; she simply declines to work without it.",
    image: IMAGES.ele,
    portrait: true,
  },
];

export const FOUNDER_LETTER = {
  heading: "It began with a question about the jar.",
  paragraphs: [
    "Some years ago, I stood in a pet shop holding a tin of mushroom powder for dogs and could not find out what was in it. Not where it grew, not how it was made, not whether it had ever been near a forest at all. Ezekiel, waiting by the door, was getting grey around the muzzle. I put the tin back.",
    "So we went looking. We walked the foothills and the Kananaskis valleys in every season, learned which birch carried chaga and which hemlock carried reishi, and learned, mostly from the dogs, that the best things are found slowly. Kane, Malakai and Ele joined the walks, and then the work.",
    "Dirty Paws Apothecary is the answer I wanted that day in the shop. Every jar carries a batch number, every batch is tested by an independent laboratory, and every result is written in the ledger for anyone to read. Nothing rushed, nothing hidden.",
    "Thank you for trusting us with your dog. We know exactly what that means.",
  ],
  signature: "The Founder",
  role: "Dirty Paws Apothecary · Alberta",
  image: "/assets/founder-walk-v5.webp",
  caption: "The first walk of most mornings: Ezekiel, Kane, Malakai and Ele, a little after dawn.",
};

/* The letter as published on dirtypawsapothecary.com. */
export const LIVE_LETTER = {
  ...FOUNDER_LETTER,
  heading: "For the ordinary days that mean everything.",
  role: "Dirty Paws Apothecary",
  paragraphs: [
    "There is a particular cruelty in loving dogs. No matter how many years we're given, we will always wish for a few more.",
    "I think about that more often than I'd like to admit.",
    "Our lives revolve around four rather extraordinary characters: Ezekiel, Kane, Malakai, and Ele. Between them, they've claimed most of the furniture, rearranged our daily routines, and made it nearly impossible to leave the house without an explanation.",
    "They have also given us a life I wouldn't trade for anything.",
    "Some of our best days have been the least remarkable. Long walks through the foothills. Muddy paws across the kitchen floor. Four dogs finding their places at the end of the day, entirely unaware of how much those small moments mean to us.",
    "And somewhere in the middle of all those ordinary days, I began thinking about how to have more of them.",
    "Not because I believe there's a way to stop time. There isn't. But because I believe the years we do have deserve our closest attention.",
    "That curiosity led us into the extraordinary world of fungi, traditional preparations, and the evolving science of mushroom compounds. The more we learned, the more questions we asked. About sourcing. About quality. About what the research supports, what it doesn't, and why those distinctions matter.",
    "Eventually, those questions became Dirty Paws Apothecary.",
    "We built it around a simple conviction: if something is going into our dogs' bodies, we should know exactly what it is, where it came from, and why it belongs there.",
    "No grand promises. No borrowed certainty. Just thoughtfully sourced mushroom preparations, transparent testing, and a genuine respect for the science, including the things it has yet to tell us.",
    "The four dogs who founded us remain largely unconcerned with these details. Their priorities are considerably more immediate.",
    "A walk. A good meal. Their favourite place beside us.",
    "And perhaps that's the whole point.",
    "We're not trying to make every day extraordinary. We're simply hoping for more of the ordinary ones.",
    "For the ordinary days that mean everything.",
  ],
};


export const DOG_PICKS = {
  Ezekiel: { productId: "grey_muzzle_reserve", pronoun: "His", line: "Presides over all meetings from a seated position of considerable gravity." },
  Kane: { productId: "riverbend_calm", pronoun: "His", line: "Approaches each tasting with the gravity of a wine critic." },
  Malakai: { productId: "trailhead_vigor", pronoun: "His", line: "Has personally inventoried every mushroom patch in the Kananaskis." },
  Ele: { productId: "foresters_guard", pronoun: "Her", line: "No batch leaves the shelf without her inspection." },
};

export const formatCad = (cents) =>
  document.documentElement.lang === "fr"
    ? `${(cents / 100).toFixed(2).replace(/\.00$/, "").replace(".", ",")} $ CA`
    : `$${(cents / 100).toFixed(2).replace(/\.00$/, "")} CAD`;

export const FREE_CARRIAGE_CENTS = 12500;
export const CARRIAGE_CENTS = 1500;
export const packPctFor = (jars) => (jars >= 3 ? 15 : jars === 2 ? 10 : 0);
